import styled from "styled-components";
import {Row} from "antd";

export const StyledRow = styled(Row)`
  box-shadow: 0px 2px 6px rgba(176, 186, 197, 0.600289);
  width: 100%;
  position: relative;
  background: #fff;
  padding: 24px;
  border-radius: 8px;

  .dot-blinking{
    animation: 1s blinker linear infinite;
    -webkit-animation: 1s blinker linear infinite;
    -moz-animation: 1s blinker linear infinite;
  }

  @-moz-keyframes blinker {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes blinker {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes blinker {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
	
  
  .ant-select {
    width: 100%;

    &:hover, &:focus {
      .ant-select-selector {
        border-color: #51258F !important;
        box-shadow: none !important;
      }
    }

    .ant-select-selector {
      height: 40px;
    }

    .ant-select-selection-item {
      line-height: 38px;
    }
  }
`

export const StyledEducationOrdersContainer = styled.div`
	
  margin-top: 12px;
  
	.transferText{
		color: #1890FF;
		font-size: 14px;
		line-height: 20px;
		text-decoration: underline;
		cursor: pointer;
	}

  .unclassified {

    background: #fff !important;

    .ant-table-cell {
      background: #fff !important;
    }

    &:hover {
      background: #fff !important;
    }
  }

  .succeeded {
    background: rgba(220, 241, 223, 0.4) !important;

    .ant-table-cell {
      background: rgba(220, 241, 223, 0.4) !important;
    }

    &:hover {
      background: rgba(220, 241, 223, 0.4) !important;
    }
  }

  .declined {
    background: rgba(227, 57, 60, 0.14) !important;

    .ant-table-cell {
      background: rgba(227, 57, 60, 0.14) !important;
    }

    &:hover {
      background: rgba(227, 57, 60, 0.14) !important;
    }
  }

  .exclude {
    background: rgba(129, 83, 240, 0.14) !important;

    .ant-table-cell {
      background: rgba(129, 83, 240, 0.14) !important;
    }

    &:hover {
      background: rgba(129, 83, 240, 0.14) !important;
    }
  }

  .inLine {
    background: rgba(253, 201, 68, 0.14) !important;

    .ant-table-cell {
      background: rgba(253, 201, 68, 0.14) !important;
    }

    &:hover {
      background: rgba(253, 201, 68, 0.14) !important;
    }
  }

  .transferred {
    background: rgba(24, 144, 255, 0.14) !important;

    .ant-table-cell {
      background: rgba(24, 144, 255, 0.14) !important;
    }

    &:hover {
      background: rgba(24, 144, 255, 0.14) !important;
    }
  }
	
	.ant{
		&-tabs{
			&-nav{
				&-wrap{
          margin-left: 16px;

          .ant-tabs-tab-active{
            background: #51258F !important;
            border: none !important;
            .ant-tabs-tab-btn{
	            color: #fff !important;
            }
          }
					
					.ant-tabs-tab{
						border-radius: 4px;
						padding: 8px 16px;
						background: #fff;
						border: 1px solid #51258F;
						color: #51258F;
					}
					
					.ant-tabs-ink-bar{
						display: none;
					}
				}
			}
		}
		
		&-table{
			&-container{
				border-radius: 8px;

        .ant-table-header, .ant-table-content {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;

          table {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;

            thead {
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              
              th{
                border-inline-end: 1px solid #C4C8CB !important;
              }
	            
	            .ant-table-cell {
                background: rgba(81, 37, 143, 0.2) !important;
		            text-align: center;
		            font-size: 11px;
		            font-weight: 700;
		            line-height: 16px;
		            color: #2E384D;
                border-color: #C4C8CB;
              }
            }
          }
        }

        .ant-table-body {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;

          table {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            tbody {
              border-bottom-left-radius: 8px;
              border-bottom-right-radius: 8px;

              td{
                border-inline-end: 1px solid #C4C8CB !important;
                border-color: #C4C8CB;
              }
            }
          }
        }
			}
		}
	}
`